// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1q2Sg","header":"PatientBlock_header__1gQev","label":"PatientBlock_label__3dQ_w","option":"PatientBlock_option__3PL-I"};